/**
 * ef-061 anchor (Spec Architect, FROZEN) — the Home tile ids, titles and DEFAULT order. Pure data (no React),
 * so a Playwright spec can import it to prove it agrees with the server's registry
 * (`HomeTileRegistry.cs`: same ids, same titles, same order). `tileRegistry.ts` adds the components.
 * No slice edits this file.
 */
export interface TileMeta {
  /** The wire id a saved layout stores. */
  id: string;
  /** What the picker and the tile heading call it. */
  title: string;
}

export const TILE_META: readonly TileMeta[] = [
  { id: "cash", title: "Cash and income" },
  { id: "next-payroll", title: "Next payroll" },
  { id: "needs-you", title: "Needs you" },
  { id: "bills-due", title: "Bills due" },
  { id: "activity", title: "Recent activity" },
  { id: "reminders", title: "Reminders" },
];

/** The default layout, before the permission filter (every tile is owner-only today). */
export const DEFAULT_TILE_IDS: readonly string[] = TILE_META.map((t) => t.id);

/**
 * Every rendered tile's WRAPPER carries `data-testid={TILE_TESTID_PREFIX + id}` — a documented, tested
 * contract (`ui-breadcrumbs.md` §2: the tile's own role+name pair is not unique on Home, e.g. "Next payroll"
 * is also a fixed card). Nothing else on Home may use this prefix.
 */
export const TILE_TESTID_PREFIX = "home-tile-";
